<div class="tw-flex tw-h-full tw-w-full tw-justify-center md:tw-mb-[88px] md:tw-pt-0">
  <div class="tw-flex tw-h-full tw-w-full tw-flex-col md:tw-my-0 md:tw-h-full">
    <nav class="tw-relative tw-mt-3 tw-mb-6 tw-flex tw-w-full tw-items-center tw-gap-3">
      <a
        class="tw-h-11 tw-w-11 tw-flex tw-items-center tw-justify-center tw-rounded-[6px] tw-cursor-pointer hover:tw-bg-color-surface-card tw-transition-colors tw-flex-shrink-0 tw-z-30 tw-no-underline"
        [routerLink]="previousRoute"
      >
        <icon [name]="'left-arrow'" [size]="6" [currentColor]="'color-text-secondary'"></icon>
      </a>
      <div class="title-mobile">
        <span class="tw-text-xl tw-font-semibold tw-text-color-text-default">{{
          title | i18n
        }}</span>
      </div>
    </nav>
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
</div>
